module.exports = __webpack_public_path__ + "img/noRiskMarker.06401988.svg";